import { environment } from "./environments/environment";

export const apiURL = environment.API_URL;
export const FILES_URL = `${apiURL}/files`;
export const googleClientId = environment.GOOGLE_CLIENT_ID;
export const newsPageSize = parseInt(environment.NEWS_PAGE_SIZE || "6", 10);
console.log("API URL:", apiURL);
